
export const rts = {
  handleSetViewItems: 'handleSetViewItems',
}

export const viewSettingsMenuReducer = (state, action) => {

  const { type } = action

  switch (type) {
    case rts.handleSetViewItems:
      return {
        ...state,
        ...action.vsmProps
      }

    default:
      return { ...state }
  }
}

export const viewSettingsMenuInitialState = (initState) => {
  return { ...initState }
};

export const viewSettingsMenuHandlers = (dispatch, state) => {
  return {
    handleSetViewItems: (vsmProps) => { dispatch({ type: rts.handleSetViewItems, vsmProps }) },
  }
} 